import { Button, Modal } from "react-bootstrap";
import "./Successfull_Modal.css";

const Successfull_Modal = (props) => {
  setTimeout(() => {
    props?.onHide();
  }, 5000);

  return (
    <section className="Successfull_Modal">
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Successfull_Modal modal-holder"
      >
        <Modal.Header closeButton> </Modal.Header>
        <Modal.Body>
          <div className="animation_holder">{props?.lottie}</div>

          <div className="text_holder">
            <h6>{props?.message}</h6>
            <p>{props?.subMessage}</p>
          </div>

          <div className="btn_holder">
            <Button className="okay_btn" type="button" onClick={props.onHide}>Okay</Button>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default Successfull_Modal;
